import { FormSkillGroupManagementType } from 'components/types/company';
import { FormActivityType } from 'components/types/company/activityType';

export const preparePayloadSkillGroup = (datas: FormSkillGroupManagementType, typeForm: string) => {
  const { data } = datas;

  const { sub_skill_group, ...restData } = data;

  const dataPayload = {
    ...restData,
    skill_group_action: typeForm,
    sub_skill_group: sub_skill_group.map((item) => ({
      ...item,
      sub_skill_group_action: typeForm,
    })),
  };

  return dataPayload;
};

export const preparePayloadActivityType = (datas: FormActivityType, dataId: number) => {
  const { member, ...restData } = datas;

  const dataPayload = {
    ...restData,
    wla_activity_type_id: dataId,
  };

  return dataPayload;
};
